import _ from 'lodash';
import moment from 'moment';
import { MyXLSX2 } from '@/utils/xlsxExport2';
import { invoiceType, invoiceStatus } from '@/assets/commonData/options';

let CD;

export default {
    created() {
        CD = moment().format('YYYY-MM-DD');
    },
    methods: {
        async onExport() {
            const wb = MyXLSX2.createBook();
            this.isLoadingExport = true;

            try {
                const details = this.selectedDatas.length > 0
                    ? await this.getExportDataBySelected()
                    : await this.getExportData({
                        ...this.OrderParam,
                        ...this.prevQuery,
                    });

                const toBeAuditSheet = this.getBeforeIssuedSheet(details, '待審核', 0);
                const toBeIssueSheet = this.getBeforeIssuedSheet(details, '待開立', 1);
                const toBeArriveSheet = this.getAfterIssuedSheet(details, '待入帳', 2);
                const completeSheet = this.getAfterIssuedSheet(details, '完成', 3);
                const rejectSheet = this.getRejectedSheet(details, '退件', 4);
                const incomeSheet = this.getIncomeSheet(details);

                if (toBeAuditSheet) {
                    MyXLSX2.bookAppendSheet(wb, toBeAuditSheet, '發票帳款總表 - 待審核');
                }
                if (toBeIssueSheet) {
                    MyXLSX2.bookAppendSheet(wb, toBeIssueSheet, '發票帳款總表 - 待開立');
                }
                if (toBeArriveSheet) {
                    MyXLSX2.bookAppendSheet(wb, toBeArriveSheet, '發票帳款總表 - 待入帳');
                }
                if (completeSheet) {
                    MyXLSX2.bookAppendSheet(wb, completeSheet, '發票帳款總表 - 完成');
                }
                if (rejectSheet) MyXLSX2.bookAppendSheet(wb, rejectSheet, '發票帳款總表 - 退件');
                MyXLSX2.bookAppendSheet(wb, incomeSheet, '發票入帳明細');

                MyXLSX2.download(wb, `發票${CD}`);
            } catch (e) {
                console.log(e);
                this.$message({
                    showClose: true,
                    message: '無資料可匯出',
                    type: 'error',
                });
            } finally {
                this.isLoadingExport = false;
            }
        },

        getBeforeIssuedSheet(oriDetails, subTitle, status) {
            const details = _.filter(oriDetails, ['status', status]);
            if (!details.length) return null;
            const title = `發票帳款總表 - ${subTitle}`;

            // 內容表頭
            const bodyHeader = [
                // 資訊
                { text: '', width: 5, align: 'center' },
                { text: '單號', align: 'center' },
                { text: '摘要', width: 30, align: 'left' },
                { text: '專案系統編號', width: 15, align: 'center' },
                { text: '專案自訂編號', width: 15, align: 'center' },
                { text: '專案名稱', width: 40, align: 'left' },
                { text: '申請備註', width: 30, align: 'left' },
                { text: '狀態', align: 'center' },
                { text: '買受人（客戶）', width: 30, align: 'left' },
                // 立帳
                { text: '發票類型', align: 'center' },
                { text: '銷售額(未稅)', align: 'right', number: true },
                { text: '營業稅', align: 'right', number: true },
                { text: '幣別', align: 'center' },
                { text: '即時匯率', width: 10, align: 'right' },
                { text: '含稅總計', align: 'right', number: true },
                {
                    text: '含稅總計約當台幣',
                    width: 20,
                    align: 'right',
                    number: true,
                },
                // 金流
                { text: '預計收款日', align: 'center' },
            ];

            // 內容資料
            const bodyRows = [];
            details.forEach((item) => {
                const row = [
                    // 資訊
                    '',
                    item.ioo,
                    item.description,
                    this.getInvoiceProjectSno(item),
                    this.getInvoiceProjectCustomNumber(item),
                    this.getInvoiceProjectName(item),
                    item.mem || '',
                    _.find(invoiceStatus, ['key', item.status])?.value,
                    item.vdR_NAM,
                    // 立帳
                    _.find(invoiceType, ['key', item.typ])?.value,
                    item.amt - item.amT_TAX,
                    item.amT_TAX,
                    item.cny,
                    this.getCnyRat(item.cny),
                    item.amt,
                    item.amt * this.getCnyRat(item.cny),
                    // 金流
                    item.pdat ? moment(item.pdat).format('YYYY-MM-DD') : '--',
                ];
                bodyRows.push(row);
            });
            // 總計列
            const totalAmt = _.sumBy(details, (o) => o.amt * this.getCnyRat(o.cny));
            const totalNonTaxAmt = _.sumBy(details, (o) => o.amt - o.amT_TAX);
            const totalTaxAmt = _.sumBy(details, 'amT_TAX');

            bodyRows.push([
                // 資訊
                '',
                '總計(約當台幣)',
                '',
                '',
                '',
                '',
                '',
                '',
                '',
                // 立帳
                '',
                totalNonTaxAmt,
                totalTaxAmt,
                '',
                '',
                '',
                totalAmt,
                // 金流
                '',
            ]);

            // 表頭資訊
            const headRows = [...this.getQueryText(), { label: '發票金額總計（約當台幣）', value: totalAmt }, ...this.getTrimCnyStatistic(details), { label: '製表日期', value: CD }];

            return MyXLSX2.createInvoiceSheet(title, headRows, bodyHeader, bodyRows, '開立前');
        },

        getRejectedSheet(oriDetails, subTitle, status) {
            const details = _.filter(oriDetails, ['status', status]);
            if (!details.length) return null;
            const title = `發票帳款總表 - ${subTitle}`;

            // 內容表頭
            const bodyHeader = [
                // 資訊
                { text: '', width: 5, align: 'center' },
                { text: '單號', align: 'center' },
                { text: '摘要', width: 30, align: 'left' },
                { text: '專案系統編號', width: 15, align: 'center' },
                { text: '專案自訂編號', width: 15, align: 'center' },
                { text: '專案名稱', width: 40, align: 'left' },
                { text: '申請備註', width: 30, align: 'left' },
                { text: '狀態', align: 'center' },
                { text: '退件人', align: 'center' },
                { text: '退件日期', align: 'center' },
                { text: '退件原因', width: 20, align: 'left' },
                { text: '買受人（客戶）', width: 30, align: 'left' },
                // 立帳
                { text: '發票類型', align: 'center' },
                { text: '銷售額(未稅)', align: 'right', number: true },
                { text: '營業稅', align: 'right', number: true },
                { text: '幣別', align: 'center' },
                { text: '即時匯率', width: 10, align: 'right' },
                { text: '含稅總計', align: 'right', number: true },
                {
                    text: '含稅總計約當台幣',
                    width: 20,
                    align: 'right',
                    number: true,
                },
            ];

            // 內容資料
            const bodyRows = [];
            details.forEach((item) => {
                const row = [
                    // 資訊
                    '',
                    item.ioo,
                    item.description,
                    this.getInvoiceProjectSno(item),
                    this.getInvoiceProjectCustomNumber(item),
                    this.getInvoiceProjectName(item),
                    item.mem || '',
                    _.find(invoiceStatus, ['key', item.status])?.value,
                    _.find(item.audits, (o) => !!o.rsn)?.stF_NAM,
                    _.find(item.audits, (o) => !!o.rsn)?.sdat ? moment(_.find(item.audits, (o) => !!o.rsn)?.sdat).format('YYYY-MM-DD') : '--',
                    _.find(item.audits, (o) => !!o.rsn)?.rsn,
                    item.vdR_NAM,
                    // 立帳
                    _.find(invoiceType, ['key', item.typ])?.value,
                    item.amt - item.amT_TAX,
                    item.amT_TAX,
                    item.cny,
                    this.getCnyRat(item.cny),
                    item.amt,
                    item.amt * this.getCnyRat(item.cny),
                ];
                bodyRows.push(row);
            });
            // 總計列
            const totalAmt = _.sumBy(details, (o) => o.amt * this.getCnyRat(o.cny));
            const totalNonTaxAmt = _.sumBy(details, (o) => o.amt - o.amT_TAX);
            const totalTaxAmt = _.sumBy(details, 'amT_TAX');

            bodyRows.push([
                // 資訊
                '',
                '總計(約當台幣)',
                '',
                '',
                '',
                '',
                '',
                '',
                '',
                '',
                '',
                '',
                // 立帳
                '',
                totalNonTaxAmt,
                totalTaxAmt,
                '',
                '',
                '',
                totalAmt,
            ]);

            // 表頭資訊
            const headRows = [...this.getQueryText(), { label: '發票金額總計（約當台幣）', value: totalAmt }, ...this.getTrimCnyStatistic(details), { label: '製表日期', value: CD }];

            return MyXLSX2.createInvoiceSheet(title, headRows, bodyHeader, bodyRows, '退件');
        },

        getAfterIssuedSheet(oriDetails, subTitle, status) {
            const details = _.filter(oriDetails, ['status', status]);
            if (!details.length) return null;
            const title = `發票 - ${subTitle}`;

            // 內容表頭
            const bodyHeader = [
                // 資訊
                { text: '', width: 5, align: 'center' },
                { text: '單號', align: 'center' },
                { text: '摘要', width: 30, align: 'left' },
                { text: '專案系統編號', width: 15, align: 'center' },
                { text: '專案自訂編號', width: 15, align: 'center' },
                { text: '專案名稱', width: 40, align: 'left' },
                { text: '申請備註', width: 30, align: 'left' },
                { text: '收入項目', width: 60, align: 'left' },
                { text: '狀態', align: 'center' },
                { text: '買受人（客戶）', width: 30, align: 'left' },
                // 立帳
                { text: '發票類型', align: 'center' },
                { text: '發票號碼', align: 'center' },
                { text: '發票日期', align: 'center' },
                { text: '銷售額(未稅)', align: 'right', number: true },
                { text: '營業稅', align: 'right', number: true },
                { text: '幣別', width: 10, align: 'center' },
                { text: '發票匯率', width: 10, align: 'right' },
                { text: '含稅總計', align: 'right', number: true },
                {
                    text: '含稅總計約當台幣',
                    width: 20,
                    align: 'right',
                    number: true,
                },
                { text: '開立備註', width: 30, align: 'left' },
                { text: '銷貨折讓及退回', align: 'right', number: true },
                { text: '銷貨折讓及退回日期', width: 20, align: 'center' },
                // 金流
                { text: '預計收款日', align: 'center' },
                { text: '幣別', width: 10, align: 'center' },
                { text: '入帳總額', align: 'right', number: true },
                {
                    text: '入帳總額約當台幣',
                    width: 20,
                    align: 'right',
                    number: true,
                },
                { text: '退款總額', align: 'right', number: true },
                {
                    text: '退款總額約當台幣',
                    width: 20,
                    align: 'right',
                    number: true,
                },
                {
                    text: '帳款未收金額',
                    width: 20,
                    align: 'right',
                    number: true,
                },
                { text: '帳款已收金額', align: 'right', number: true },
                {
                    text: '帳款已收金額約當台幣',
                    width: 30,
                    align: 'right',
                    number: true,
                },
                { text: 'Sokuji 完成日期', align: 'center' },
                { text: '收款天數', width: 20, align: 'center' },
                { text: '帳款備註', width: 30, align: 'left' },
            ];

            // 內容資料
            const bodyRows = [];
            details.forEach((item) => {
                const INCOME_TWD = _.chain(item.incomes)
                    .filter(['flg', 1])
                    .sumBy((o) => o.amount * o.rat)
                    .value();
                const REFUND_TWD = _.chain(item.incomes)
                    .filter(['flg', -1])
                    .sumBy((o) => o.amount * o.rat)
                    .value();
                const row = [
                    // 資訊
                    '',
                    item.ioo,
                    item.description,
                    this.getInvoiceProjectSno(item),
                    this.getInvoiceProjectCustomNumber(item),
                    this.getInvoiceProjectName(item),
                    item.mem || '',
                    this.getHierarchyItemName(item.incomeItemNo, item.incomeItemName),
                    _.find(invoiceStatus, ['key', item.status])?.value,
                    item.vdR_NAM,
                    // 立帳
                    _.find(invoiceType, ['key', item.typ])?.value,
                    item.typ !== 4 ? item.foo || '(未開立)' : '-',
                    item.foO_DAT ? moment(item.foO_DAT).format('YYYY-MM-DD') : '--',
                    item.amt - item.amT_TAX,
                    item.amT_TAX,
                    item.cny,
                    item.rat,
                    item.amt,
                    item.amt * item.rat,
                    item.comment || '',
                    item.foO_DIS_AMT,
                    item.foO_DIS_DAT ? moment(item.foO_DIS_DAT).format('YYYY-MM-DD') : '--',
                    // 金流
                    item.pdat ? moment(item.pdat).format('YYYY-MM-DD') : '--',
                    item.cny,
                    item.invoiceTotalIncoming,
                    INCOME_TWD,
                    item.invoiceTotalRefund,
                    REFUND_TWD,
                    item.amt - item.foO_DIS_AMT - (item.invoiceTotalIncoming - item.invoiceTotalRefund),
                    item.invoiceTotalIncoming - item.invoiceTotalRefund,
                    (item.invoiceTotalIncoming - item.invoiceTotalRefund) * item.rat,
                    this.getCompleteDate(item),
                    this.getMoneyDays(item),
                    item.bankNote || '',
                ];
                bodyRows.push(row);
            });
            // 總計列
            const totalAmt = _.sumBy(details, (o) => o.amt * o.rat);
            const totalDisAmt = _.sumBy(details, (o) => o.foO_DIS_AMT * o.rat);
            const totalIncoming = _.sumBy(details, (o) => o.invoiceTotalIncoming * o.rat);
            const totalRefound = _.sumBy(details, (o) => o.invoiceTotalRefund * o.rat);
            const totalNonIncome = _.sumBy(details, (o) => o.amt - o.foO_DIS_AMT - (o.invoiceTotalIncoming - o.invoiceTotalRefund));
            const totalCredited = _.sumBy(details, (o) => (o.invoiceTotalIncoming - o.invoiceTotalRefund) * o.rat);
            const avgCompleteDay = _.chain(details)
                .filter((o) => Number.isInteger(this.getMoneyDays(o)))
                .meanBy((o) => this.getMoneyDays(o))
                .value();
            const totalNonTaxAmt = _.sumBy(details, (o) => o.amt - o.amT_TAX);
            const totalTaxAmt = _.sumBy(details, 'amT_TAX');

            bodyRows.push([
                // 資訊
                '',
                '總計(約當台幣)',
                '',
                '',
                '',
                '',
                '',
                '',
                '',
                '',
                // 立帳
                '',
                '',
                '',
                totalNonTaxAmt,
                totalTaxAmt,
                '',
                '',
                '',
                totalAmt,
                '',
                totalDisAmt,
                '',
                // 金流
                '',
                '',
                totalIncoming,
                '',
                totalRefound,
                '',
                totalNonIncome,
                '',
                totalCredited,
                '平均收款天數',
                avgCompleteDay ? Math.round(avgCompleteDay * 100) / 100 : '--',
                '',
            ]);

            // 表頭資訊
            const headRows = [
                ...this.getQueryText(),
                { label: '發票金額總計（約當台幣）', value: totalAmt },
                { label: '折讓金額總計（約當台幣）', value: totalDisAmt },
                { label: '已收金額總計（約當台幣）', value: totalIncoming },
                { label: '退款金額總計（約當台幣）', value: totalRefound },
                { label: '未收金額總計（約當台幣）', value: totalCredited },
                ...this.getTrimCnyStatistic(details),
                { label: '製表日期', value: CD },
            ];

            return MyXLSX2.createInvoiceSheet(title, headRows, bodyHeader, bodyRows, '開立後');
        },

        getIncomeSheet(oriDetails) {
            const details = _.flatMap(oriDetails, (o) => (o.incomes
                ? _.map(o.incomes, (x) => ({
                    vdR_NAM: o.vdR_NAM,
                    cny: o.cny,
                    foo: o.foo,
                    foO_DAT: o.foO_DAT,
                    description: o.description,
                    projects: o.projects,
                    ...x,
                }))
                : []));
            const title = '發票入帳明細';

            // 內容表頭
            const bodyHeader = [
                { text: '', width: 5, align: 'center' },
                { text: '單號', align: 'center' },
                { text: '摘要', width: 30, align: 'left' },
                { text: '專案系統編號', width: 15, align: 'center' },
                { text: '專案自訂編號', width: 15, align: 'center' },
                { text: '專案名稱', width: 40, align: 'left' },
                { text: '買受人（客戶）', width: 30, align: 'left' },
                { text: '發票號碼', align: 'center' },
                { text: '發票日期', align: 'center' },
                { text: '入帳方式', align: 'left' },
                { text: '幣別', width: 10, align: 'center' },
                { text: '入帳金額', align: 'right', number: true },
                { text: '匯率', width: 10, align: 'right' },
                { text: '約當台幣', align: 'right', number: true },
                { text: '入帳日期', align: 'center' },
                { text: '銀行', width: 20, align: 'center' },
                { text: '入帳備註', width: 30, align: 'left' },
            ];

            // 內容資料
            const bodyRows = [];
            details.forEach((item) => {
                const row = [
                    '',
                    item.ioo,
                    item.description,
                    this.getInvoiceProjectSno(item),
                    this.getInvoiceProjectCustomNumber(item),
                    this.getInvoiceProjectName(item),
                    item.vdR_NAM,
                    item.foo,
                    item.foO_DAT ? moment(item.foO_DAT).format('YYYY-MM-DD') : '--',
                    this.getIncomeType(item),
                    item.cny,
                    item.flg > 0 ? item.amount : -item.amount,
                    item.rat,
                    item.flg > 0 ? item.amount * item.rat : -item.amount * item.rat,
                    item.bnK_DAT ? moment(item.bnK_DAT).format('YYYY-MM-DD') : '--',
                    item.bnK_TPC || '--',
                    item.mem || '',
                ];
                bodyRows.push(row);
            });
            // 總計列
            const totalAmt = _.sumBy(details, (o) => o.amount * o.rat);

            bodyRows.push([
                // 資訊
                '',
                '總計(約當台幣)',
                '',
                '',
                '',
                '',
                '',
                '',
                '',
                '',
                '',
                '',
                '',
                totalAmt,
                '',
                '',
                '',
            ]);

            // 表頭資訊
            const headRows = [...this.getQueryText(), { label: '入帳金額總計（約當台幣）', value: totalAmt }, { label: '製表日期', value: CD }];

            return MyXLSX2.createSheet(title, headRows, bodyHeader, bodyRows);
        },

        async getExportData(params) {
            const PageSize = 1000;
            let PageNum = 1;
            const { query, resetQuery } = this.getManualQuery(this.prevQuery);
            const url = `InvoiceManagemnetPage/QueryInvoice${query}`;

            const { data } = await this.$api({
                url,
                method: 'GET',
                params: {
                    ...params,
                    ...resetQuery,
                    PageNum: 1,
                    PageSize,
                },
            });

            // 足夠的PageSize
            if (PageSize > data.totalNum) {
                return data.items;
            }

            const currentList = [...data.items];
            for (let i = 0; i < Math.ceil(data.totalNum / PageSize) - 1; i += 1) {
                PageNum += 1;
                // eslint-disable-next-line no-await-in-loop
                const resp = await this.$api({
                    url,
                    method: 'GET',
                    params: { ...params, PageNum, PageSize },
                });
                currentList.push(...resp.data.items);
            }
            return currentList;
        },

        async getExportDataBySelected() {
            const details = [];
            for (let i = 0; i < this.selectedDatas.length; i += 1) {
                const { sno } = this.selectedDatas[i];
                // eslint-disable-next-line no-await-in-loop
                const resp = await this.$api({
                    url: '/InvoiceManagemnetPage/GetInvoiceInfo',
                    method: 'GET',
                    params: { Sno: sno },
                });
                if (resp.data.item.item) details.push(resp.data.item.item);
            }
            return details;
        },

        getQueryText() {
            const LIST = [
                { text: '單號、發票號碼', field: 'IooOrFOO' },
                { text: '開立日期', field: 'queryDate', isDate: true },
                {
                    text: '客戶',
                    field: 'VendorId',
                    options: this.vendorOptions,
                    optionFind: 'sno',
                    optionField: 'fnam',
                },
                {
                    text: '我的專案',
                    field: 'ProjectId',
                    options: this.projectOptions,
                    optionFind: 'sno',
                    optionField: 'nam',
                },
                {
                    text: '申請人',
                    field: 'Creators',
                    options: this.creatorOptions,
                    optionFind: 'sno',
                    optionField: 'nam',
                },
                { text: '入帳日期', field: 'queryReceiveDate', isDate: true },
                {
                    text: '入帳銀行帳戶',
                    field: 'bankSnos',
                    options: this.$store.getters['bankAccount/bankAccountOptions'],
                    optionFind: 'sno',
                    optionField: 'tpc',
                },
                { text: '收支項目', field: 'itemSnos', textOnly: true },
                { text: '金額下限', field: 'AMT_Min' },
                { text: '金額上限', field: 'AMT_Max' },
                { text: '幣別', field: 'cnyList' },
            ];

            const RETURN = [];

            LIST.forEach((item) => {
                const VALUE = this.prevQuery[item.field];
                if ((!Array.isArray(VALUE) && VALUE) || (Array.isArray(VALUE) && VALUE.length)) {
                    const OPTIONS = item.options;
                    if (item.textOnly) {
                        RETURN.push({
                            label: item.text,
                            value: `${VALUE.length === 1 ? '單選' : `複選(${VALUE.length})`}`,
                        });
                    } else if (Array.isArray(VALUE)) {
                        if (item.isDate) {
                            const sd = moment(VALUE[0]).format('YYYY-MM-DD');
                            const ed = moment(VALUE[1]).format('YYYY-MM-DD');
                            RETURN.push({
                                label: item.text,
                                value: `${sd} ~ ${ed}`,
                            });
                        } else if (OPTIONS) {
                            const LIST_TEXT = _.map(VALUE, (o) => _.find(OPTIONS, [item.optionFind, o])[item.optionField]);
                            RETURN.push({
                                label: item.text,
                                value: LIST_TEXT.join(', '),
                            });
                        } else {
                            RETURN.push({
                                label: item.text,
                                value: VALUE.join(', '),
                            });
                        }
                    } else if (OPTIONS) {
                        const FOUND = _.find(OPTIONS, [item.optionFind, VALUE])[item.optionField];
                        RETURN.push({ label: item.text, value: FOUND });
                    } else {
                        RETURN.push({
                            label: item.text,
                            value: VALUE,
                        });
                    }
                }
            });

            return RETURN.length ? RETURN : [{ label: '查詢條件', value: '不限' }];
        },

        getCnyRat(cny) {
            const cnyOption = this.$store.getters['cny/cnyOptions'].find((x) => x.cny === cny);
            if (cnyOption) return cnyOption.rat;
            return 1;
        },

        getMoneyDays(item) {
            const SDAT = _.find(item.audits, ['menU_UNT', 'B03']).sdat;
            // console.log(item.status === 2 ? '待' : '完', SDAT, item.bnK_DAT);
            if (!item.bnK_DAT || !SDAT || !item.foO_DAT) return '--';
            const a = moment(item.bnK_DAT);
            const b = moment(item.foO_DAT);
            return a.diff(b, 'days');
        },

        getCompleteDate(item) {
            const SDAT = _.find(item.audits, ['menU_UNT', 'B03']).sdat;
            if (!SDAT) return '--';
            return moment(SDAT).format('YYYY-MM-DD') || '--';
        },
        getTrimCnyStatistic(details) {
            const cnyOptions = this.$store.getters['cny/cnyOptions'];
            const cnyStatisticList = [];
            cnyOptions.forEach((item, i) => {
                const amt = _.chain(details)
                    .filter(['cny', item.cny])
                    .sumBy('amt')
                    .value();
                if (amt) {
                    cnyStatisticList.push({
                        cny: item.cny,
                        label: !i ? '各幣別總額' : '',
                        value: `${item.cny}: ${amt.toLocaleString('en-US')}`,
                    });
                }
            });
            if (cnyStatisticList.length === 1 && _.first(cnyStatisticList).cny === 'TWD') return [];
            return cnyStatisticList;
        },
        getIncomeType(item) {
            if (item.flg > 0) {
                switch (item.receiveIncomeType) {
                case 0:
                    return '銀行匯款';
                case 1:
                    return '收現金存銀行';
                default:
                    return '收現金存零用金';
                }
            }
            switch (item.receiveIncomeType) {
            case 0:
                return '銀行匯款（退）';
            default:
                return '零用現金退費';
            }
        },
        /**
         * 根據收入項目的 SNO 組合出三階層名稱（例如：營業收入 / 銷貨收入 / 商品銷售收入）
         * @param {Number} itemSno 收入項目編號
         * @param {String} fallbackName 備用名稱（未對應到時使用）
         * @returns {String} 三階層名稱
         */
        getHierarchyItemName(itemSno, fallbackName) {
            if (!itemSno) return fallbackName || '--';
            const statementOptionsForUi = this.$store.getters['statement/statementUiOptions'];
            if (!statementOptionsForUi) return fallbackName || '--';

            const hierarchy = [null, null, null];
            const types = [
                { key: 'payoutSettings', name: '營業支出' },
                { key: 'invoiceSettings', name: '營業收入' },
                { key: 'cInSettings', name: '營業其他收入' },
                { key: 'cInElseSettings', name: '財務資產收入' },
                { key: 'cOutSettings', name: '營業其他支出' },
                { key: 'cOutElseSettings', name: '財務資產支出' },
            ];

            let found = false;
            for (let t = 0; t < types.length; t += 1) {
                const options = statementOptionsForUi[types[t].key];
                if (!options) continue;
                for (let i = 0; i < options.length; i += 1) {
                    const lv1Item = options[i];
                    if (!lv1Item.childSettings) continue;
                    for (let j = 0; j < lv1Item.childSettings.length; j += 1) {
                        const lv2Item = lv1Item.childSettings[j];
                        if (lv2Item.sno === itemSno) {
                            hierarchy[0] = types[t].name;
                            hierarchy[1] = lv1Item.iteM_NAM;
                            hierarchy[2] = lv2Item.iteM_NAM;
                            found = true;
                            break;
                        }
                    }
                    if (found) break;
                }
                if (found) break;
            }

            if (!found) return fallbackName || '--';
            return hierarchy.join(' / ');
        },
        getInvoiceProjectSno(item) {
            const LIST = _.chain(item.projects).map('poo').filter((o) => o).value();
            return LIST.length ? LIST.join(',') : '-';
        },
        getInvoiceProjectCustomNumber(item) {
            const LIST = _.chain(item.projects).map('customnumber').filter((o) => o).value();
            return LIST.length ? LIST.join(',') : '-';
        },
        getInvoiceProjectName(item) {
            const LIST = _.chain(item.projects).map('pjcaT_NAM').filter((o) => o).value();
            return LIST.length ? LIST.join(',') : '-';
        },
    },
};
